// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 942) return "css/942-feff6461.css";
	if (chunkId === 678) return "css/678-44c0b40a.css";
	if (chunkId === 45) return "css/45-23851c00.css";
	// return url for filenames based on template
	return "css/" + ({"81":"trxns_css","398":"newspaper_css","638":"app_css","740":"print"}[chunkId] || chunkId) + "-" + {"81":"d59e5aff","221":"17ee6b11","398":"18277bc3","638":"43675e18","740":"1c38418b"}[chunkId] + ".css";
};